import type { DocPageContent } from '../docs-content'

const page = {
  order: 16,
  slug: 'scene-browser',
  title: '场景浏览器与 AI 分析',
  description:
    '在本地分析媒体以生成场景字幕，然后按关键词、语义或颜色搜索。',
  category: '创意工具',
  related: ['media', 'local-ai', 'source-monitor'],
  sections: [
    {
      title: '使用 AI 分析',
      blocks: [
        {
          kind: 'list',
          items: [
            '在媒体库的某个片段上，或从场景浏览器的**分析**菜单中运行**使用 AI 分析**。',
            '该过程完全在你的机器上运行：它会检测场景、为每一幕生成字幕、提取调色板，并构建文本与图像嵌入（embeddings）。',
            '为没有字幕的片段选择**分析新素材**，或选择**重新分析全部**以刷新所有内容。',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '结果会按内容缓存，因此相同的媒体会被复用，而无需再次分析。',
        },
      ],
    },
    {
      title: '打开场景浏览器',
      blocks: [
        {
          kind: 'list',
          items: [
            '从媒体库打开场景浏览器，或按 `Ctrl+Shift+F`。',
            '它会搜索由“使用 AI 分析”生成的 AI 字幕与场景数据。',
            '将范围设为全部已分析媒体或单个片段，并按**相关度**、**时间戳**或**媒体名称**排序。',
            '在**列表视图**与**网格视图**之间切换，以适应浏览或快速扫描。',
          ],
        },
      ],
    },
    {
      title: '搜索模式',
      blocks: [
        {
          kind: 'table',
          headers: ['模式', '匹配依据'],
          rows: [
            ['关键词', '字幕中的确切词语——适合查找特定对象或标签。'],
            [
              '语义',
              '含义，因此“水上的日落”能找到相关场景（首次使用会下载一个约 22 MB 的小模型）。',
            ],
            ['颜色', '相似的调色板——从库调色板中选取一个色板。'],
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '结果带有匹配徽章——强、良好或一般——并注明匹配是依据关键词、含义、视觉相似度还是颜色。',
        },
      ],
    },
    {
      title: '使用搜索结果',
      blocks: [
        {
          kind: 'list',
          items: [
            '点击某个场景以在源监视器中预览它。',
            '将某个场景拖到时间轴上，把那一刻加入你的剪辑。',
            '如果什么都没找到，请确认该片段已被分析——只有已分析的媒体才能被搜索。',
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
